import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Paper, TextField, Typography } from '@mui/material';

import SaveButton from '../ui/SaveButton';
import AbEnvironment from '../auth/AbEnvironment';
import Address from '../ui/Address'
import CustomerValidationFetch from './CustomerValidationFetch';
import AppBindStyles from '../../AppBindStyles';


const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  sectionTitleFirst: {
    marginBottom: 3,
    textAlign: 'left'
  },
  sectionTitle: {
    marginTop: 15,
    marginBottom: 3,
    textAlign: 'left'
  }
});

class CustomerCreateForm extends React.Component {
  state = {
    dupCustomer: false,
    dupEmail: false,
    saveStatus: null,
    saveMessage: null,
    parentId: abEnvironment.getUserAttribute('a_id'),
    accountType: 4,
    accountNum: '',
    customerName:   '',
    description: '',
    contactLastName: '', 
    contactFirstName: '', 
    contactEmail: '', 
    contactPhone: '',
    address1:    '',
    address2:    '',
    city:        '',
    state:       '',
    country:     '',
    postalCode:  ''
  }

  componentDidMount() {
    if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription create (opened customer create form)'); }
  }

  disableCustomerSave() {

      const { validateEmail } = this.props.auth;

      if (this.state.dupCustomer) {
        return true;
      }

      if (this.state.dupEmail) {
        return true;
      }

      if (this.state.customerName == null || this.state.customerName.length === 0)
        return true;

      if (this.state.contactLastName == null || this.state.contactLastName.length === 0)
        return true;

      if (this.state.contactFirstName == null || this.state.contactFirstName.length === 0)
        return true;

      if (this.state.contactEmail == null || this.state.contactEmail.length === 0)
        return true;


      // Is email an email address?
      let emailOk = validateEmail(this.state.contactEmail);
      if (! emailOk)
        return true;

      return false;
  }

  handleSnackbarClose = (ev) => {
    this.setState({ saveStatus: null });
  }

  validateCustomer = (ev) => {

    let accountId = abEnvironment.getUserAttribute('a_id');

    //this gets a list of all the apps associated with the program
    CustomerValidationFetch.fetch(accountId, this.state.customerName).toPromise()
    .then(cvf => {
      if (cvf.allAccountTs.totalCount === 1) {
        this.setState({dupCustomer: true});
      } else {
        this.setState({dupCustomer: false});
      }
      
    })
    .catch(err => {
      //nothing to do....
    })

  }

  validateEmailDuplicate = (ev) => {

    const { callPartnerApi, logError } = this.props.auth;
 
    // Check on uniqueness prior to account or user persistence.
    callPartnerApi('appbind/usercount/' + this.state.contactEmail,
                   'GET',
                   null)
    .then(response => {
      return response.json();
    })
    .then(data => {
      if (data.userCount != null)
      {
        if (data.userCount > 0)
        {
          this.setState({dupEmail: true});

        } else {
          this.setState({dupEmail: false});
        }
      }
      else
      {
        throw(data);
      }
    }).catch(err => {

      logError('Exception in CustomerCreateForm.js: ' + err);
    })

  }

  handleSave = (ev) => {

    if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription create saving customer (created on the fly)'); }

    const { parentId, accountNum, customerName, description,
      contactLastName, contactFirstName, contactEmail, contactPhone,
      address1, address2, city, state, country, postalCode } = this.state;

    let theNewAccountId = null;
    const { callPartnerApi } = this.props.auth;

    let aPjwt = abEnvironment.getPjwt();

    let payload = {
      operation: "createCustomerAndProject",
      params: {
        pJwt: aPjwt,
        parentId: parentId,
        accountNum: accountNum,
        accountName: customerName,
        description: description,
        contactLastName: contactLastName,
        contactFirstName: contactFirstName,
        contactEmail: contactEmail,
        contactPhone: contactPhone,
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        country: country,
        postalCode: postalCode
      }
    };


    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {

      if (response.err != null)
      {
        throw response.err;  
      }

      theNewAccountId = response.data.createAccountT.accountT.accountId;

      // Increment the customer count...
      let custCount = parseInt(abEnvironment.getUserAttribute("cust_count"), 10) + 1;
      abEnvironment.setUserAttribute("cust_count", custCount);

      let theNewCust = {
        accountId:        theNewAccountId,
        accountName:      this.state.customerName,
        description:      this.state.description,
        userName:         null,
        contactLastName:  this.state.contactLastName,
        contactFirstName: this.state.contactFirstName,
        contactEmail:     this.state.contactEmail,
        contactPhone:     this.state.contactPhone,
        address1:         this.state.address1,
        address2:         this.state.address2,
        city:             this.state.city,
        state:            this.state.state,
        country:          this.state.country,
        postalCode:       this.state.postalCode
      }

      this.props.onClose(theNewCust);
      this.setState({ showSpinner: false });
      if (abEnvironment.isSegmentActive()) {  window.analytics.track('Subscription create saved customer (created on the fly)'); }
    })
    .catch(error => {
      //console.log('Customer create mutation error: ' + error);
      let theError = 'Unable to save new customer';
      if (error.errMessage != null) {
        theError = error.errMessage;
      }

      this.setState({ showSpinner: false, snackbarOpen: true, saveStatus: 'error', saveMessage: theError });
    });
  }

  setCountry    = (country)    => { this.setState({country:    country}); }  
  setRegion     = (region)     => { this.setState({state:      region}); }  
  setCity       = (city)       => { this.setState({city:       city}); }  
  setPostalCode = (postalCode) => { this.setState({postalCode: postalCode}); }  
  setAddress1   = (address1)   => { this.setState({address1:   address1}); }  
  setAddress2   = (address2)   => { this.setState({address2:   address2}); }  

  render() {

    const classes = this.props.classes;

    //console.log(JSON.stringify(this.props));
    const { validateEmail } = this.props.auth;

    let address = {
      country:    this.state.country,
      state:      this.state.state,
      city:       this.state.city,
      postalCode: this.state.postalCode,
      address1:   this.state.address1,
      address2:   this.state.address2
    };
    let regionLabel = "Region";

    let emailError = false;
    if (this.state.contactEmail != null && this.state.contactEmail !== '') {
      let emailOk = validateEmail(this.state.contactEmail);
      if (! emailOk) {
        emailError = true;
      }
    }  

    return (
      <form onSubmit={this.handleSave}>


        <Grid container spacing={2} >

          <Grid item xs={12}>
            <TextField 
              error={this.state.dupCustomer}
              id="customer-name" label="Customer name *"
              value={ this.state.customerName }
              onBlur={() => { this.validateCustomer() }}
              onChange={ (e) => this.setState({ customerName: e.target.value }) }
              inputProps={{ maxLength: 64 }}
              helperText={this.state.dupCustomer ? 'Customer already exists with this name' : ''}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" className={classes.sectionTitle}>
              Primary contact
            </Typography>
          </Grid>
 

          <Grid item  xs={12} sm={6}>
            <TextField  data-recording-ignore="mask"
              id="first-name" label="First name *"
              value={ this.state.contactFirstName }
              onChange={ (e) => this.setState({ contactFirstName: e.target.value }) }
              inputProps={{ maxLength: 32 }}
            />
          </Grid>
          <Grid item  xs={12} sm={6}>
            <TextField  data-recording-ignore="mask"
              id="last-name" label="Last name *"
              value={ this.state.contactLastName }
              onChange={ (e) => this.setState({ contactLastName: e.target.value }) }
              inputProps={{ maxLength: 32 }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField  data-recording-ignore="mask"
              id="email" label="Email *"
              error={this.state.dupEmail || emailError}
              value={ this.state.contactEmail }
              onBlur={() => { this.validateEmailDuplicate() }}
              onChange={ (e) => this.setState({ contactEmail: e.target.value }) }
              helperText={this.state.dupEmail ? 'User already exists with this email' : ''}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
              {/* remove this grid item when we bring phone back */}
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={1}>
              <Grid container spacing={1} direction="row" justifyContent="flex-start" style={{padding: '16px'}}>
                <Grid item xs={12}>
                  <div style={{display:"flex"}}>
                    <Typography variant="body1">
                      <strong>Tip.</strong>&nbsp;&nbsp;Your customer will only be emailed when you say so.
                    </Typography>
                  </div>
                </Grid>      
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h6" className={classes.sectionTitle}>
              Mailing address
            </Typography>
          </Grid>

           <Grid item xs={12}>
            <Address
              showRequired={false}
              address={address}
              regionLabel={regionLabel}
              setCountryCodeState={this.setCountry}
              setRegionCodeState={this.setRegion}
              setCityState={this.setCity}
              setPostalCodeState={this.setPostalCode}
              setAddress1State={this.setAddress1}
              setAddress2State={this.setAddress2}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} direction="row" 
              justifyContent="flex-start"
              style={{marginTop:'20px',textAlign:'left'}}>
          <Grid item xs={12} align="center">
            <div id="card-errors" role="alert"></div>
            <SaveButton
              snackbarOpen={this.state.saveStatus==='error'}
              autoHideDuration={null}
              label="Save Customer"
              size="large"
              status={this.state.saveStatus} 
              message={this.state.saveMessage}
              disabled={this.disableCustomerSave()}
              onSaveClick={(ev) => {this.handleSave(ev)}}
              onSnackbarClose={(ev) => {this.handleSnackbarClose()}}/>
            <Button color="primary" variant="outlined" size="large" style={AppBindStyles.bottomButton} onClick={() => {this.props.onClose()}}>Cancel</Button>
          </Grid>
        </Grid>
      </form>
    );
  }
}

/*
CustomerCreateForm.propTypes = {
  classes: PropTypes.object.isRequired,
};
*/
export default withStyles(styleSheet)(CustomerCreateForm);
